import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useKraCycleStore from '../../store/kraCycleStore';
import KRAFilters, { matchesName } from '../../components/KRAFilters';

const STATUS_LABELS = {
  draft: 'Not Started',
  self_submitted: 'External Inputs Pending',
  external_pending: 'External Inputs Pending',
  ready_for_hod: 'Ready for Review',
  locked: 'Reviewed',
  reopened: 'Reopened',
};

const TeamReviewPage = () => {
  const { cycles, isLoading, fetchCycles } = useKraCycleStore();
  const [nameFilter, setNameFilter] = useState('');
  const [monthFilter, setMonthFilter] = useState(''); // "YYYY-MM", '' = every month

  useEffect(() => {
    // No employee_id filter — the backend already scopes the list to this
    // HOD's direct reports (via Employee.reports_to_id) server-side, or to
    // everyone for CEO/HR. Month is filtered server-side too (the API takes
    // any date within the month) so picking one doesn't pull every month's
    // cycles for the whole company; name is filtered locally below.
    fetchCycles(monthFilter ? { month: `${monthFilter}-01` } : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monthFilter]);

  const visible = cycles.filter((c) => matchesName(c.employee_name, nameFilter));

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-white mb-6">Team KRA — Review Queue</h1>

        <KRAFilters
          name={nameFilter}
          onNameChange={setNameFilter}
          month={monthFilter}
          onMonthChange={setMonthFilter}
          shown={visible.length}
          total={isLoading ? null : cycles.length}
        />

        {isLoading ? (
          <p className="text-gray-500">Loading...</p>
        ) : cycles.length === 0 ? (
          <div className="glass-card p-6 text-sm text-gray-500">
            {monthFilter ? 'No KRA records for that month.' : 'Nothing in your review queue right now.'}
          </div>
        ) : visible.length === 0 ? (
          <div className="glass-card p-6 text-sm text-gray-500">No records match "{nameFilter.trim()}".</div>
        ) : (
          <div className="glass-card divide-y divide-gray-100">
            {visible.map((c) => (
              <Link key={c.id} to={`/kra/team/${c.id}`} className="flex items-center justify-between px-5 py-4 hover:bg-gray-50">
                <div>
                  <div className="font-semibold text-gray-900">{c.employee_name}</div>
                  <div className="text-xs text-gray-500 mt-0.5">
                    {new Date(c.month).toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}
                    {c.external_inputs_required > 0 && ` · External ${c.external_inputs_received}/${c.external_inputs_required}`}
                  </div>
                </div>
                <span className="text-xs font-semibold px-2 py-1 rounded bg-gray-200 text-gray-700">
                  {STATUS_LABELS[c.status] || c.status}
                </span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamReviewPage;
